import { OTPInput } from "../base-ui/OTPInput";
import { TOTP_CODE_LENGTH } from "@/components/mfa/totp";
import type { TotpChallenge } from "@/components/mfa/useTotpChallenge";
import { Button } from "@/components/ui/buttons/button";
import { safeAsync } from "@/lib/utils";
import type { FormEvent } from "react";

export const PasswordRecoveryMfaChallenge = ({
  challenge,
  isCreatingPassword = false,
}: {
  challenge: TotpChallenge;
  isCreatingPassword?: boolean;
}) => {
  const errorMessageId = "password-recovery-mfa-code-error";

  return (
    <form
      id="auth-update-password-step-up"
      onSubmit={safeAsync(async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (
          challenge.code.length !== TOTP_CODE_LENGTH ||
          challenge.isVerifying
        ) {
          return;
        }
        await challenge.verify();
      })}
    >
      <div className="flex flex-col space-y-4 text-left">
        <p className="text-center text-sm text-content-tertiary">
          Enter the code from your authenticator app before{" "}
          {isCreatingPassword ? "creating" : "resetting"} your password.
        </p>
        <div>
          <OTPInput
            value={challenge.code}
            onChange={challenge.setCode}
            length={TOTP_CODE_LENGTH}
            onComplete={
              challenge.requiresRetry
                ? undefined
                : (code) => void challenge.verify(code)
            }
            disabled={challenge.isVerifying}
            autoFocus
            error={Boolean(challenge.error)}
            errorMessageId={errorMessageId}
          />
          {challenge.error && (
            <p
              id={errorMessageId}
              role="alert"
              className="mt-1 text-center text-sm text-red-500"
            >
              {challenge.error}
            </p>
          )}
        </div>
        {challenge.requiresRetry && (
          <Button type="submit" disabled={!challenge.canVerify}>
            {challenge.isVerifying ? "Retrying..." : "Retry"}
          </Button>
        )}
      </div>
    </form>
  );
};
